var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04405 14.6292C0.41969 10.8613 -1.25021 5.25209 1.36169 2.08355C3.93078 -1.04218 9.75405 -0.528368 14.3784 3.23963C19.0028 7.05044 20.6298 12.6596 18.0608 15.7853C15.4917 18.9539 9.6684 18.4401 5.04405 14.6292Z",
    fill: "url(#paint0_linear_1_257)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3421 14.2864C1.18874 10.861 -0.309896 5.80845 2.00228 2.98245C4.31446 0.156455 9.58109 0.627455 13.7345 4.0529C17.8878 7.43554 19.3864 12.4881 17.0314 15.3141C14.7193 18.1401 9.49545 17.7119 5.3421 14.2864V14.2864Z",
    fill: "url(#paint1_linear_1_257)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1171 15.2287C17.0885 15.2572 17.06 15.2858 17.0314 15.3143C14.7193 18.1403 9.49545 17.7121 5.3421 14.2867C1.18874 10.8612 -0.309896 5.80867 2.00228 2.98268C2.03083 2.95413 2.05937 2.92559 2.08792 2.89705C-0.0958069 5.72304 1.40283 10.7328 5.51337 14.0726C9.58109 17.4552 14.7621 17.9262 17.1171 15.2287V15.2287Z",
    fill: "#A86314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_257",
    x1: 22.471,
    y1: 10.8184,
    x2: 13.3508,
    y2: 21.9083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_257",
    x1: 20.671,
    y1: 11.4604,
    x2: 14.7193,
    y2: 18.7395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin16);
export default __webpack_public_path__ + "static/media/coin16.74a5f0a46425c95563faec3e0da0c3f1.svg";
export { ForwardRef as ReactComponent };